module.exports = __webpack_public_path__ + "static/img/m_global_download_logo@3x.1ad2b0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_download_logo@3x.png
// module id = o5VR
// module chunks = 1